import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onboardingAPI } from '../../services/api';
import { Button } from '../ui/button';
import { Confetti, X, ArrowRight } from '@phosphor-icons/react';
import { formatDistanceToNow } from 'date-fns';
import { toast } from 'sonner';

const OnboardingAlerts = () => {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);

  const load = () => onboardingAPI.alerts().then(res => setAlerts(res.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const dismiss = async (a) => {
    try { await onboardingAPI.dismissAlert(a.id); setAlerts(prev => prev.filter(x => x.id !== a.id)); }
    catch { toast.error('Could not dismiss'); }
  };

  if (!alerts.length) return null;
  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50/80 p-4 sm:p-5 space-y-3" data-testid="onboarding-alerts">
      <div className="flex items-center gap-2">
        <Confetti weight="duotone" className="w-5 h-5 text-emerald-700" />
        <h3 className="font-heading font-semibold text-emerald-900">{alerts.length} applicant{alerts.length !== 1 ? 's' : ''} finished onboarding — ready to hire</h3>
      </div>
      <div className="space-y-2">
        {alerts.map(a => (
          <div key={a.id} className="flex items-center gap-3 rounded-xl bg-white/80 border border-emerald-100 px-3 py-2" data-testid={`onboarding-alert-${a.id}`}>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium truncate">{a.first_name} {a.last_name}</p>
              <p className="text-xs text-muted-foreground truncate">Completed {formatDistanceToNow(new Date(a.completed_at), { addSuffix: true })} · {a.email}{a.completion_email_sent ? ' · office emailed' : ''}</p>
            </div>
            <Button size="sm" className="rounded-xl gap-1 bg-emerald-600 hover:bg-emerald-700" onClick={() => navigate('/caregivers?tab=onboarding')} data-testid={`review-alert-${a.id}`}>Review <ArrowRight className="w-3.5 h-3.5" /></Button>
            <Button variant="ghost" size="sm" className="h-8 w-8 p-0 text-muted-foreground" onClick={() => dismiss(a)} title="Dismiss" data-testid={`dismiss-alert-${a.id}`}><X className="w-4 h-4" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnboardingAlerts;
